/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PartitionValueFilter } from './partitionValueFilter';


export interface BusinessObjectDataDdlRequest { 
    namespace: string;
    businessObjectDefinitionName: string;
    businessObjectFormatUsage: string;
    businessObjectFormatFileType: string;
    businessObjectFormatVersion?: number;
    partitionValueFilters?: Array<PartitionValueFilter>;
    partitionValueFilter?: PartitionValueFilter;
    businessObjectDataVersion?: number;
    /**
     * An optional Business Object Data Status value for available Business Object Data. Accepted values are VALID and all                   pre-registration status values, such as PROCESSING, UPLOADING, and PENDING_VALID. Default value is VALID. The request cannot                   contain both businessObjectDataVersion and businessObjectDataStatus values                
     */
    businessObjectDataStatus?: string;
    storageNames?: Array<string>;
    storageName?: string;
    outputFormat: BusinessObjectDataDdlRequest.OutputFormatEnum;
    tableName: string;
    customDdlName?: string;
    includeDropTableStatement?: boolean;
    includeIfNotExistsOption?: boolean;
    includeDropPartitions?: boolean;
    /**
     * If true, for partitioned table, LOCATION statement will be added to the generated DDL with the value set to the first partition                   bucket name followed by the namespace prefix                
     */
    includeSingleLocation?: boolean;
    allowMissingData?: boolean;
    /**
     * Specifies to perform an exhaustive search to return availability for ALL registered sub-partitions (registered as individual                   business object data instances) except for the ones with \"DELETED\" status. This parameter has no impact when business object data version is                   specified. Default value is false, which means that this endpoint ignores any \"not available\" registered sub-partitions when it finds at least                   one \"VALID\" registered sub-partition for a requested business object data partition value.                   If true, the call would fail with a \"Not Found\" (status code 404) error when it finds at least one \"not available\" (except for \"DELETED\")                   registered sub-partition for a requested business object data partition value                
     */
    includeAllRegisteredSubPartitions?: boolean;
    /**
     * Specifies to suppress scanning of registered storage files to discover sub-partitions and instead of that relies on business                   object data registration information to extract primary and sub-partition (if any) values required to identify Hive table partitions. Default                   value is false. If true, the call would fail with a \"Bad Request\" (status code 400) error when number of partitions in any of the discovered                   business object data instances does not match to the number of partition columns in the business object format being used to generate the DDL                   or retrieve business object partitions                
     */
    suppressScanForUnregisteredSubPartitions?: boolean;
    /**
     * Specifies to add multiple partitions in a single ALTER TABLE statement. If includeDropPartitions is set to true, this flag also                   specifies to drop multiple partitions in a single ALTER TABLE statement                
     */
    combineMultiplePartitionsInSingleAlterTable?: boolean;
    /**
     * Specifies the maximum number of add partition statements to include in a single ALTER TABLE statement. If includeDropPartitions                   is set to true, this parameter also applies to maximum number of drop partition statements in a single ALTER TABLE statement                
     */
    combinedAlterTableMaxPartitions?: number;
    /**
     * Specifies the date and time when the business object status was effective at that time, (ex 2015-12-30T11:08:40).                   The feature of 'asOfTime' looks for business object data SOLELY based on business object data status history,                   and it does NOT look for storage file status history for the business object selected                
     */
    asOfTime?: Date;
    /**
     * Specifies not to place single quotes around partition values where the columns are of numeric datatype
     */
    suppressQuotesInNumericTypePartitionValues?: boolean;
}
export namespace BusinessObjectDataDdlRequest {
    export type OutputFormatEnum = 'HIVE_13_DDL';
    export const OutputFormatEnum = {
        HIVE13DDL: 'HIVE_13_DDL' as OutputFormatEnum
    };
}
